import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";

// confirmation for deleting tasks/sub-tasks
export function DeleteConfirmDialog({
  open,
  onOpenChange,
  subject,
  name,
  lines,
  busy,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  subject: "task" | "sub-task";
  name?: string | null;
  lines: string[];
  busy?: boolean;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this {subject}?</AlertDialogTitle>
          <AlertDialogDescription>
            {name
              ? <><span className="font-medium text-foreground">{name}</span> will be deleted.</>
              : <>This {subject} will be deleted.</>}
            {lines.map((line) => <span key={line}> {line}</span>)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: "destructive" })}
            disabled={busy}
            onClick={onConfirm}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
